export const roundDecimal = (number, places = 2) => number.toFixed(places) / 1;
